import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "096pgk60",
    dataset: "production"
})